import React from 'react';
import PropTypes from 'prop-types';
import { SpacerVertical } from '@klarna/bubble-ui';

import { ProductIndicator, MidIndicator } from '@/components';

const Indicator = ({ products }) => (
  <>
    <ProductIndicator products={products} />
    <SpacerVertical spaceToken="space/150" />
    <MidIndicator />
  </>
);

Indicator.propTypes = {
  products: PropTypes.array.isRequired,
};

export default Indicator;
